import { render, staticRenderFns } from "./EditarUnidad.vue?vue&type=template&id=c422f0f8"
import script from "./EditarUnidad.vue?vue&type=script&lang=js"
export * from "./EditarUnidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports